module.exports = __webpack_public_path__ + "reportedPhotoThumbnail.c889080.png";